import { z } from 'zod';

// Form-level schema. Radio buttons emit strings ('si' / 'no'), so we
// validate as a string and transform to boolean in the submit handler
// before sending to the backend (which expects `asiste: boolean`).
export const rsvpSchema = z.object({
  asiste: z
    .string()
    .refine((v) => v === 'si' || v === 'no', {
      message: 'Indicá si asistís o no',
    }),
  acompanantes_confirmados: z.coerce
    .number({ invalid_type_error: 'Debe ser un número' })
    .int('Debe ser un número entero')
    .min(0, 'No puede ser negativo'),
  cancion_sugerida: z
    .string()
    .max(500, 'Máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
});